// This file was automatically generated from uiwidget.Icd10ListEditor.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.Icd10ListEditor');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Icd10ListEditor.billDxEntryField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div aria-label="ICD-10 list" role="list" class="billing-dxs-container el8BillingDxSection ', (opt_data.index != undefined) ? 'billing-dxs-' + soy.$$escapeHtml(opt_data.index) : '', '" ', (opt_data.index != undefined) ? 'data-mle-index=\'' + soy.$$escapeHtml(opt_data.index) + '\'' : '', '></div>', (! opt_data.hideCheckbox) ? '<div class="el8Hidden mt5 dual-coding-checkbox-section">' + ((! opt_data.isShowAndPrint) ? '<label class="ml10 mr5 el8Static el8NormalWeight">Show Dual Coding</label>' : '<label class="ml10 mr5 el8Static el8NormalWeight">Show &amp; Print Dual Codes</label>') + '<input class="dual-coding-checkbox" type="checkbox" ' + ((opt_data.isShowDualCodingEnabled) ? 'checked' : '') + '/></div>' : '', '<div class="el8BillingDxEntryField el8EditorTextareaWrap mr5"><input aria-label="ICD-10 input" type="text" class="w100 billing-dx-input ebs-form-control" name="', (opt_data.index != undefined) ? 'dxs_' + soy.$$escapeHtml(opt_data.index) : 'dxs', '" data-testid="dx-text"></input></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Icd10ListEditor.referralBillDxEntryField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MailFieldPadding billing-dxs-container el8BillingDxSection"></div><div class="el8MailFieldPadding el8FieldSection el8Hidden mt5 dual-coding-checkbox-section"><label class="el8FieldMailShowDualCoding">Show Dual Coding</label><input class="dual-coding-checkbox" type="checkbox" ', (opt_data.isShowDualCodingEnabled) ? 'checked' : '', '/></div><div class="el8MailFieldPadding el8BillingDxEntryField el8EditorTextareaWrap mr5"><input type="text" class="w100 billing-dx-input ebs-form-control" name="dxs"></input></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Icd10ListEditor.icd10Line = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div aria-label="ICD-10 entry" role="listitem" class="el8BillingIcd10Line billing-icd10-line" data-code="', soy.$$escapeHtml(opt_data.icd10Code.code), '" data-id="', soy.$$escapeHtml(opt_data.icd10Code.id), '" data-index="', soy.$$escapeHtml(opt_data.index), '">', (opt_data.sortable) ? '<div class="el8InlineBlock w3 dx-sort"><span class="el8SortIcon"></span></div>' : '', '<div class="el8InlineBlock w7 el8VAlignTop el8999">Dx<span class="billing-icd10-label"></span>:</div><div class="el8InlineBlock w90 el8VAlignTop"><span aria-label="ICD-10 code" class="el8Code el8Inline el8Bold el8333">', soy.$$escapeHtml(opt_data.icd10Code.code), '</span> - <span aria-label="ICD-10 description" class="">', soy.$$escapeHtml(opt_data.icd10Code.description), '</span><span class="billing-icd9-list el8CodeSmaller el8CursorPointer ', (! opt_data.showDualCoding) ? 'el8Hidden' : '', '">');
  if (opt_data.icd9Codes && opt_data.icd9Codes.length) {
    output.append(' (');
    var icd9List461 = opt_data.icd9Codes;
    var icd9ListLen461 = icd9List461.length;
    for (var icd9Index461 = 0; icd9Index461 < icd9ListLen461; icd9Index461++) {
      var icd9Data461 = icd9List461[icd9Index461];
      output.append('<span class="billing-icd9" data-id="', soy.$$escapeHtml(icd9Data461.id), '">', soy.$$escapeHtml(icd9Data461.code), '</span>', (! (icd9Index461 == icd9ListLen461 - 1)) ? ', ' : '');
    }
    output.append(')');
  }
  output.append('</span></div><a class="remove-icd10-line-trigger el8RemoveAttachmentButton" data-id="', soy.$$escapeHtml(opt_data.icd10Code.id), '">&times;</a></div>');
  if (!opt_sb) return output.toString();
};
